import { render, staticRenderFns } from "./jzwzTable.vue?vue&type=template&id=102f9cce&scoped=true"
import script from "./jzwzTable.vue?vue&type=script&lang=ts"
export * from "./jzwzTable.vue?vue&type=script&lang=ts"
import style0 from "./jzwzTable.vue?vue&type=style&index=0&id=102f9cce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102f9cce",
  null
  
)

export default component.exports